import dayjs from 'dayjs';

import type { MiningWeeklyRewardItem, MiningWeeklyRewardWeekGroup } from '@/services/mining-weekly-rewards';

export const formatDateTime = (value?: string | null) => {
    if (!value) return '-';
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : value;
};

/** Auto Release At = end_time + 72h */
export const formatAutoReleaseAt = (endTime?: string | null) => {
    if (!endTime) return '-';
    const parsed = dayjs(endTime);
    return parsed.isValid() ? parsed.add(72, 'hour').format('YYYY-MM-DD HH:mm:ss') : endTime;
};

export const formatPeriodRange = (start?: string | null, end?: string | null) => {
    if (!start && !end) return '-';
    const startText = start && dayjs(start).isValid() ? dayjs(start).format('MM/DD') : start || '-';
    const endText = end && dayjs(end).isValid() ? dayjs(end).format('MM/DD') : end || '-';
    return `${startText} ~ ${endText}`;
};

export const formatOutput = (value?: string | number | null) => {
    if (value === undefined || value === null || value === '') return '-';
    return String(value);
};

export const isPendingStatus = (status?: number | null) => status === 0;

export const getWeekPeriodLabel = (week?: Pick<MiningWeeklyRewardWeekGroup, 'week_n' | 'start_time' | 'end_time'>) => {
    if (!week) return '-';
    const range = formatPeriodRange(week.start_time, week.end_time);
    if (range !== '-') return range;
    return week.week_n == null ? '-' : `W${week.week_n}`;
};

export const getRewardPeriodLabel = (item?: Pick<MiningWeeklyRewardItem, 'week_n' | 'start_time' | 'end_time'>) => {
    if (!item) return '-';
    const range = formatPeriodRange(item.start_time, item.end_time);
    if (range !== '-') return range;
    return item.week_n == null ? '-' : `W${item.week_n}`;
};

export const toRewardNumber = (value?: string | number | null) => {
    if (value === undefined || value === null || value === '') return 0;
    const num = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(num) ? num : 0;
};
